import Request from '../../utils/request'
import { AxiosResponse } from 'axios'

export const enum SEARCH_TYPE {
    LIVE_ROOM = 'liveroom',
    CHANNEL = 'channel',
    LECTURE = 'lecture'
}

export const SearchServer = {
    getSearch<T>(options: { keyword: string, type: SEARCH_TYPE, offset?: number, limit?: number }) {
        const { keyword = '', type, offset = 0, limit = 10 } = options
        return Request.$get('/api/board/search', {
            params: {
                q: keyword,
                type,
                offset,
                limit
            }
        }) as Promise<AxiosResponse<ISearchData<T>>>
    }
}

export interface ISearchData<T> {
    msg: string
    code: number
    data: IData<T>
}
interface IData<T> {
    has_more: boolean
    records: T[]
    next_offset: number
}
export interface ILiveRoomItem {
    fans_count: number
    account_id: number
    verify_type: number
    description: string
    cover_url: string
    small_avatar_url: string
    avatar_url: string
    is_pass: boolean
    id: number
    badges: any[]
    name: string
}

export interface IChannelItem {
    channel_type: string
    cover: string
    cover_url: string
    description: string
    desc: number
    max: number
    id: number
    is_cost_fix: boolean
    is_preffered: boolean
    is_relay: boolean
    is_resell_center: boolean
    lecture_count: number
    liveroom_id: number
    money: number
    name: string
    need_money: boolean
    nominal_money: number
    popular: number
    preffered_reason: string
    subtitle: string
}

export interface ILectureItem {
    audio_length: number
    cover_url: string
    id: number
    image_mode: string
    is_preffered: boolean
    is_relay: boolean
    lecture_mode: string
    lecture_type: string
    liveroom_id: number
    name: string
    popular: number
    preffered_reason: string
    start_timestamp: number
    status: string
    subtitle: string
}



// WEBPACK FOOTER //
// ./src/services/Modules/searchServer.ts